// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__266LR","comment":"styles_comment__11XPe"};